<template>
    <div>
        <h2>账号注册
            <router-link :to="{path:'/sign/in'}" class="link">已有账号，去登录</router-link>
        </h2>
        <div class="content_box">
            <div class="steps" v-if="conf.is_email_register == 1 || conf.is_phone_register == 1">
                <span class="step" v-for="(item,index) in steps" :key="index" :class="{'cur':index == cur_step}">
                    <label>{{ index+1 }}</label>{{ item.name }}
                </span>
            </div>
            <register v-if="steps[cur_step].id == 'zhzc'" :conf = "conf" @next = "sign"></register>
            <auth v-if="steps[cur_step].id == 'smrz'"></auth>
            <div v-if='steps[cur_step].id == "wczc"' class="success">
                <h4><span class="el-icon-success"></span>恭喜您，注册成功</h4>
                <div class="text">
                    注意事项 <br>
                    1、请记住您的报考账号和密码，您可以使用报考账号登录网站报名参加考试！<br>
                    2、不要随便给别人您的账号和密码 <br>
                    3、如忘记密码，请至登录页点击忘记密码按提示找回密码
                </div>
                <div class="t_center">
                    <router-link :to="{path:'/'}"><el-button type="primary">注册完成，前往登录</el-button></router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Register from "@/components/sign/Register"
import Auth from "@/components/sign/Auth"
export default {
    name: '',
    components: {Register,Auth},
    data() {
        return {
            //cur_step:0,
            form:{},
            conf:{
                //is_authentication: "1",//实名认证
                //is_email_register: "0",//邮箱注册
                //is_phone_register: "1",//手机注册
                //is_register_protocol: "1",//is_register_protocol

            },//网报配置
        }
    },
    computed:{
        cur_step(){
            let step = this.$route.query.step || 0;
            return step;
        },
        steps(){
            if(this.conf.is_authentication == 1){
                return [
                    {step:1,id:"zhzc",name:"账号注册"},
                    {step:2,id:"smrz",name:"实名认证"},
                    {step:3,id:"wczc",name:"完成注册"}
                ]
            }else{
                return [
                    {step:1,id:"zhzc",name:"账号注册"},
                    {step:2,id:"wczc",name:"完成注册"}
                ]
            }
        }
    },
    created(){
        this.$store.dispatch("user/findRegWay").then(res => {
            this.conf = res.data;
        });
    },
    methods: {
        sign(data){
            this.$router.push({name:'SignRegister',query:{step:1}});
        }
    },
}
</script>
<style lang='scss' scoped src="../../assets/css/sign/register.scss"></style>